import { render, staticRenderFns } from "./CourierInfo.vue?vue&type=template&id=3e0c039e"
import script from "./CourierInfo.vue?vue&type=script&lang=js"
export * from "./CourierInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports